import React, { useEffect } from "react";
import { Box, getColor, Icons, Tooltip, Typography } from "fds";
import classNames from "classnames";
import "./index.scss";
import utilsCommon from "../../shared/utils/common";
import { useNavigate } from "react-router-dom";
import useCheckboxGroup from "../../shared/hooks/useCheckboxGroup";

import { Workgroup } from "../../types/workgroup";
import WorkgroupAvatar from "../WorkgroupAvatar";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import { getUserInfoFromLocalStorage } from "../../shared/utils/auth";
import { LoginDto } from "../../types/auth";
interface NestedSidemenuProps {
  tab: string;
  sideMenuSortby: boolean;
}

const NestedSidemenu: React.FC<NestedSidemenuProps> = ({
  tab,
  sideMenuSortby,
}) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";

  const navigate = useNavigate();
  const isOpenCheckboxGroup = useCheckboxGroup();
  const { workgroupState } = useWorkgroupStore();

  useEffect(() => {
    let openList = [];
    let startWorkgroupId = tab.split("/")[2];
    let rootWorkgroupId = "";
    while (
      (rootWorkgroupId === "" || rootWorkgroupId !== startWorkgroupId) &&
      startWorkgroupId !== undefined &&
      workgroupState?.workgroupSidemenuList?.length > 0
    ) {
      const targetWorkgroup = workgroupState?.workgroupSidemenuList?.filter(
        (item: Workgroup) => item.workgroupId === startWorkgroupId
      )[0];
      openList.push(targetWorkgroup?.parentWorkgroupId);
      startWorkgroupId = targetWorkgroup?.parentWorkgroupId;
      rootWorkgroupId = targetWorkgroup?.rootWorkgroupId;
    }
    isOpenCheckboxGroup.handleAllClick([
      ...isOpenCheckboxGroup.selected,
      ...openList,
    ]);
  }, [workgroupState?.workgroupSidemenuList, tab]);
  useEffect(() => {
    let openList = [];
    let startWorkgroupId = tab.split("/")[2];
    let rootWorkgroupId = "";
    while (rootWorkgroupId === "" || rootWorkgroupId !== startWorkgroupId) {
      const targetWorkgroup = workgroupState?.workgroupSidemenuList?.filter(
        (item: Workgroup) => item.workgroupId === startWorkgroupId
      )[0];
      openList.push(targetWorkgroup?.parentWorkgroupId);
      startWorkgroupId = targetWorkgroup?.parentWorkgroupId;
      rootWorkgroupId = targetWorkgroup?.rootWorkgroupId;
    }
    isOpenCheckboxGroup.handleAllClick([...openList]);
  }, [sideMenuSortby]);
  const renderNestedSidemenu = (item: Workgroup, depth: number) => {
    return (
      <Box direction="column">
        <Box
          classes={classNames("sidemenu-button", {
            selected: tab.includes(item.workgroupId),
          })}
          onClick={() =>
            item.workgroupJoined &&
            (item.isValidate === 1 || item.managerId === myId) &&
            navigate(
              utilsCommon.renderProperNavigatePath(
                `/workgroup/${item.workgroupId}/home`
              )
            )
          }
        >
          <Box minWidth={12 * depth} />
          <Box
            minWidth={16}
            classes="pd pr-4"
            onClick={(e: any) => {
              e.stopPropagation();
              isOpenCheckboxGroup.handleClick(item.workgroupId);
            }}
          >
            {item?.children && item?.children?.length > 0 && (
              <Icons
                variant="fill"
                label="chevron"
                size="12px"
                direction={
                  isOpenCheckboxGroup.isSelected(item.workgroupId)
                    ? "down"
                    : "right"
                }
              />
            )}
          </Box>
          <WorkgroupAvatar type="sidemenu" item={item} size="20" />
          <Tooltip
            message={item.workgroupName}
            maxWidth={`calc(100% - 20px - ${(depth + 1) * 12}px)`}
          >
            <Typography
              classes="mg ml-12"
              type="body2_rg"
              exactColor={getColor(
                window.location.href.includes(item.workgroupId)
                  ? "COLOR_TEXT_INVERSE"
                  : item.isValidate === 0 ||
                    ("workgroupJoined" in item && !item.workgroupJoined)
                  ? "COLOR_TEXT_DISABLED"
                  : "COLOR_TEXT_SECONDARY"
              )}
              ellipsis
            >
              {item.workgroupName}
            </Typography>
          </Tooltip>
        </Box>
        {item.children &&
          isOpenCheckboxGroup.isSelected(item.workgroupId) &&
          item.children.map((child) => renderNestedSidemenu(child, depth + 1))}
      </Box>
    );
  };
  return (
    <Box direction="column" width={"100%"}>
      {workgroupState?.workgroupNestedSidemenuList?.map((item: Workgroup) =>
        renderNestedSidemenu(item, 0)
      )}
    </Box>
  );
};
export default NestedSidemenu;
